module.exports = __webpack_public_path__ + "static/media/icon-chevron--bottom.796a60af.svg";